import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrl: './user-roles.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})
export class UserRolesComponent implements OnInit {
  total_leaves = 0;
  formData: FormData = new FormData();
  imagePath: any;
  selectPortalCheckIn = false;
  radioBtn_team_holidays = false;
  viewList_Chkbox_team_holidays = false;
  addNew_Chkbox_team_holidays = false;
  update_Chkbox_team_holidays = false;
  delete_Chkbox_team_holidays = false;
  objectDataJson: any;
  public showSpinner = false;
  checkbox1 = false;
  checkbox2 = false;
  showDiv = false;
  adminhidden = false;
  team_resign = false;
  team_leadteam_resign = false;
  team_lead_holidays = false;
  team_manage = false;
  employee = false;
  team_lead = false;
  admin = false;
  formGroup: any;
  departments: any;
  department: any;
  organizations: any;
  designations: any;
  employeeType: any;
  statuses: any;
  countryList: any;
  fileToUpload: any;
  first_name: any = '';
  apidata: any;
  addressdata: any;
  jsondata: any;
  prseinfo: any;
  stringinfo: any;
  uuid: any;
  user_total_working_hours: any;
  roleManagment: any;
  selected: any;
  selectedRoles: any;
  slectedEvaluation: any;
  selectedEvaluationRole: any;
  evaluationRole: any;
  roleResign: any;
  resignRoles: any;
  resignMainRoles: any;
  roleHolidays: any;
  holidaysMainRole: any;
  holidaysSubRoles: any;
  roleMedia: any;
  roleSetting: any;
  mediaMainRole: any;
  settingMainRole: any;
  mediaSubRoles: any;
  settingSubRoles: any;

  leaveManagement: any;
  leaveSubRoles: any;
  attendanceManagement: any;
  eventManagement: any;
  attendanceSubRoles: any;
  attendanceMainRole: any;
  eventSubRoles: any;
  eventMainRole: any;
  stringValue: any;
  address: any;
  admin_checkbox_value = false;
  event_checkbox_value = false;
  teamLead: any;
  leaveManagementMainRole: any;
  roleType: any;
  updatePassword = false;
  user: any;
  value: any;
  attandance_type: any;
  attendanceTpye: any;
  portalCheckInRadioGroup: any;
  leaveCount = 0;
  emp_type: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  joining: any;
  accountManagement: any;
  accountMainRole: any;
  accountSubRoles: any;
  device_name: any;
  device_id: any;
  cards: any;
  toggleValueMultiplePunch = false;
  multiplepush = 'No';
  workfromhome = 'No';
  monStartTime: any;
  monEndTime: any;
  monTotalWorkingHours: any;
  tueStartTime: any;
  tueEndTime: any;
  tueTotalWorkingHours: any;
  wedStartTime: any;
  wedEndTime: any;
  wedTotalWorkingHours: any;
  thuStartTime: any;
  thuEndTime: any;
  thuTotalWorkingHours: any;
  friStartTime: any;
  friEndTime: any;
  friTotalWorkingHours: any;
  satStartTime: any;
  satEndTime: any;
  satTotalWorkingHours: any;
  sunStartTime: any;
  sunEndTime: any;
  sunTotalWorkingHours: any;
  sharedmode: any;
  is_active = false;
  check_all = false;
  evaluation = {
    evaluationEnabled: false,
    RadioBtn_TeamEvaluation: 'null',
    team_evaluation_viewList: false,
    team_evaluation_addNew: false,
    team_evaluation_update: false,
    team_evaluation_sendEmail: false,
  };

  // team_management
  team_management = {
    radio_btn_management: 'null',
    team_managementEnabled: false,
    viewPayRoll_chkbox_team_management: false,
    updateCheckIn_chkbox_team_management: false,
    addNewUser_chkbox_team_management: false,
    createPayRoll_chkbox_team_management: false,
    deleteUser_chkbox_team_management: false,
    updateUser_chkbox_team_management: false,
    montlySalary_chkbox_team_management: false,
    loanView_chkbox_team_management: false,
    loanAccept_chkbox_team_management: false,
    loanReject_chkbox_team_management: false,
  };

  // team resign
  resign = {
    resignEnabled: false,
    radioBtn_resign: 'null',
    viewList_chekboc_team_resign: false,
    acceptResign_chekboc_team_resign: false,
    rejectResign_chekboc_team_resign: false,
  };

  // holidays
  holidays = {
    holidaysEnabled: false,
    radioBtn_holidays: 'null',
    viewList_Chkbox_team_holidays: false,
    addNew_Chkbox_team_holidays: false,
    update_Chkbox_team_holidays: false,
    delete_Chkbox_team_holidays: false,
  };

  // upload media
  upload_media = {
    upload_mediaEnabled: false,
    radioBtn_upload_media: 'null',
    viewList_chekBox_upload_media: false,
    uploadMedia_chekBox_upload_media: false,
    deleteMedia_chekBox_upload_media: false,
  };
  // Settings
  setting = {
    settingEnabled: false,
    radioBtn_setting: 'null',
    viewOrg_chekBox_setting: false,
    addOrg_chekBox_setting: false,
    editOrg_chekBox_setting: false,
    deleteOrg_chekBox_setting: false,

  };
  // leave management
  leave_management = {
    leave_managementEnabled: false,
    radioBtn_leave_management: 'null',
    viewListAllLeaves_chekBox_leave_management: false,
    acceptLeaves_chekBox_leave_management: false,
    rejectLeaves_chekBox_leave_management: false,
    updateLeaves_chekBox_leave_management: false,
    leaveReport_chekBox: false,
    resetLeave_chekBox: false,
    undoLeave_chekBox: false,
  };

  // attendance_managment
  attendance_managment = {
    attendace_managementEnable: false,
    radiobtn_attendace_management: 'null',
    viewAttendance_chkBox_attentance_management: false,
    edit_chkBox_attentance_management: false,
    sheet_chkBox_attentance_management: false,
    report_chkBox_attentance_management: false,
    delete_chkBox_attentance_management: false,
    update_chkBox_attentance_management: false,

  };
  // event Managment
  event_managment = {
    event_managementEnable: false,
    radiobtn_event_management: 'null',
    view_chkBox_event_management: false,
    add_chkBox_event_management: false,
    edit_chkBox_event_management: false,
    delete_chkBox_event_management: false,
  };
  // account managment
  account_managment = {
    account_managementEnable: false,
    radiobtn_account_management: 'null',
    view_chkBox_account_management: false,
    add_chkBox_account_management: false,
    edit_chkBox_account_management: false,
    delete_chkBox_account_management: false,
    export_chkBox_account_management: false,
    add_supperadmin_account_management: false,
  };
  statedata: any;
  stateData_id: any;
  stateRole_type: any;
  stateRole_name: any;




  constructor(

    public router: Router,
    private addService: AddService,
    public dashboardService: DashboardService,
  ) {

    // this.user = JSON.parse(localStorage.getItem('user') || '');
    // this.user_detail();
    // var user_role = JSON.parse(this.user.user_role.user_roles);
    // if (user_role.role_type == 'Employee') {
    //   this.router.navigate(['/user-dashboard']);
    // }
  }

  ngOnInit(): void {
    this.getStateData();

    this.sharedmode.data$.subscribe((mode: any) => {
      this.selectedMode = mode;
    });
  }


  // getStateData(){
  //   this.statedata = history.state.data;
  //   if( this.statedata != null ||  this.statedata != ''){
  //     this.stateData_id = this.statedata?.id;
  //     this.stateRole_name = this.statedata?.role_name;
  //     this.stateRole_type = this.statedata?.role_name;
  //   }


  // }










  backward() {
    this.router.navigate(['/setting']);
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data;
      this.colormode = this.userInfo.color_mode;
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    });
  }
  getStateData() {
    this.statedata = history.state.data;
    if (this.statedata != null && this.statedata != '' && this.statedata != undefined) {

      this.stateData_id = this.statedata?.id;
      this.stateRole_name = this.statedata?.role_name;
      this.stateRole_type = this.statedata?.role_type;
      const isActive = this.statedata?.is_active
      if (isActive == 1) {
        this.is_active = true
      } else {
        this.is_active = false
      }
      if (this.stateRole_type === 'Employee') {
        this.employee = true
      }


      this.apidata = history.state.data;
      // this.current_user_id = value?.data?.id

      this.jsondata = JSON.parse(this.apidata?.user_roles);
      this.stringinfo = this.jsondata ?? null;
      // team evaluation Section
      this.evaluationRole = this.jsondata?.team_evaluation;

      // team evaluation Section
      this.evaluationRole = this.jsondata?.team_evaluation;
      // team and all selection
      this.slectedEvaluation = this.evaluationRole?.data?.type;
      //All Role
      if (this.slectedEvaluation != null && this.slectedEvaluation === 'all') {
        this.evaluation.RadioBtn_TeamEvaluation =
          'all_RadioBtn_team_evaluation';
      } else if (
        this.slectedEvaluation != null &&
        this.slectedEvaluation === 'team'
      ) {
        this.evaluation.RadioBtn_TeamEvaluation =
          'team_RadioBtn_team_evaluation';
      } else {
        this.evaluation.RadioBtn_TeamEvaluation = 'null';
      }
      // subroles
      this.selectedEvaluationRole = this.evaluationRole?.data?.values;
      (this.evaluation.evaluationEnabled =
        this.evaluationRole?.evaluation ?? false),
        (this.evaluation.team_evaluation_viewList =
          this.selectedEvaluationRole?.view ?? false),
        (this.evaluation.team_evaluation_addNew =
          this.selectedEvaluationRole?.add ?? false),
        (this.evaluation.team_evaluation_update =
          this.selectedEvaluationRole?.update ?? false),
        (this.evaluation.team_evaluation_sendEmail =
          this.selectedEvaluationRole?.sendmail ?? false),
        // team Management Section
        (this.roleManagment = this.jsondata?.team_managment?.team_management);
      // team and all selection
      this.selected = this.jsondata?.team_managment?.data?.type;
      //attendance type
      if (this.selected != null && this.selected === 'all') {
        this.team_management.radio_btn_management =
          'all_radioBtn_team_management';
      } else if (this.selected != null && this.selected === 'team') {
        this.team_management.radio_btn_management = 'radio_btn_team_management';
      } else {
        this.team_management.radio_btn_management = 'null';
      }

      //All Role
      if (this.selected != null && this.selected === 'all') {
        this.team_management.radio_btn_management =
          'all_radioBtn_team_management';
      } else if (this.selected != null && this.selected === 'team') {
        this.team_management.radio_btn_management = 'radio_btn_team_management';
      } else {
        this.team_management.radio_btn_management = 'null';
      }
      // team_management subroles
      this.selectedRoles = this.jsondata?.team_managment?.data?.values;
      this.team_management.team_managementEnabled = this.roleManagment || false;
      this.team_management.viewPayRoll_chkbox_team_management =
        this.selectedRoles?.view || false;
      this.team_management.updateCheckIn_chkbox_team_management =
        this.selectedRoles?.update || false;
      this.team_management.addNewUser_chkbox_team_management =
        this.selectedRoles?.add || false;
      this.team_management.createPayRoll_chkbox_team_management =
        this.selectedRoles?.create || false;
      this.team_management.deleteUser_chkbox_team_management =
        this.selectedRoles?.delete || false;
      this.team_management.updateUser_chkbox_team_management =
        this.selectedRoles?.updateUser || false;
      this.team_management.montlySalary_chkbox_team_management =
        this.selectedRoles?.monthly_salary || false;
      this.team_management.loanView_chkbox_team_management =
        this.selectedRoles?.loanView || false;
      this.team_management.loanAccept_chkbox_team_management =
        this.selectedRoles?.loanAccept || false;
      this.team_management.loanReject_chkbox_team_management =
        this.selectedRoles?.loanReject || false;

      // Resign Data
      // resign main role
      this.roleResign = this.jsondata?.resign_data?.resign;
      this.resign.resignEnabled = this.roleResign || false;
      // resign data type team or all
      this.resignRoles = this.jsondata?.resign_data?.data?.type;
      //All Role
      if (this.resignRoles != null && this.resignRoles === 'all') {
        this.resign.radioBtn_resign = 'all_radioBtn_team_resign';
      } else if (this.resignRoles != null && this.resignRoles === 'team') {
        this.resign.radioBtn_resign = 'team_radioBtn_team_resign';
      } else {
        this.resign.radioBtn_resign = 'null';
      }
      // All Sub Roles
      this.resignMainRoles = this.jsondata?.resign_data?.data?.values;
      this.resign.viewList_chekboc_team_resign =
        this.resignMainRoles?.view || false;
      this.resign.acceptResign_chekboc_team_resign =
        this.resignMainRoles?.accept || false;
      this.resign.rejectResign_chekboc_team_resign =
        this.resignMainRoles?.reject || false;

      // holidays data
      // holidays main role
      this.roleHolidays = this.jsondata?.holdays_data?.holidays;
      this.holidays.holidaysEnabled = this.roleHolidays || false;
      // holidays data type team or all
      this.holidaysMainRole = this.jsondata?.holdays_data?.data?.type;
      //All Role
      if (this.holidaysMainRole != null && this.holidaysMainRole === 'all') {
        this.holidays.radioBtn_holidays = 'all_radioBtn_team_holidays';
      } else if (
        this.holidaysMainRole != null &&
        this.holidaysMainRole === 'team'
      ) {
        this.holidays.radioBtn_holidays = 'team_radioBtn_team_holidays';
      } else {
        this.holidays.radioBtn_holidays = 'null';
      }

      // All Sub Roles
      this.holidaysSubRoles = this.jsondata?.holdays_data?.data?.values;
      this.holidays.viewList_Chkbox_team_holidays =
        this.holidaysSubRoles?.view || false;
      this.holidays.addNew_Chkbox_team_holidays =
        this.holidaysSubRoles?.add || false;
      this.holidays.update_Chkbox_team_holidays =
        this.holidaysSubRoles?.update || false;
      this.holidays.delete_Chkbox_team_holidays =
        this.holidaysSubRoles?.delete || false;

      // upload media data
      // upload media main role
      this.roleMedia = this.jsondata?.upload_data?.upload_media;
      this.upload_media.upload_mediaEnabled = this.roleMedia || false;
      // holidays data type team or all
      this.mediaMainRole = this.jsondata?.upload_data?.data?.type;
      //All Role
      if (this.mediaMainRole != null && this.mediaMainRole === 'all') {
        this.upload_media.radioBtn_upload_media = 'all_radioBtn_upload_media';
      } else if (this.mediaMainRole != null && this.mediaMainRole === 'team') {
        this.upload_media.radioBtn_upload_media = 'team_radioBtn_upload_media';
      } else {
        this.upload_media.radioBtn_upload_media = 'null';
      }

      // All Sub Roles
      this.mediaSubRoles = this.jsondata?.upload_data?.data?.values;
      this.upload_media.viewList_chekBox_upload_media =
        this.mediaSubRoles?.view || false;
      this.upload_media.uploadMedia_chekBox_upload_media =
        this.mediaSubRoles?.accept || false;
      this.upload_media.deleteMedia_chekBox_upload_media =
        this.mediaSubRoles?.reject || false;

      //Settings main role

      this.roleSetting = this.jsondata?.settings?.setting;
      this.setting.settingEnabled = this.roleSetting || false;
      // holidays data type team or all
      this.settingMainRole = this.jsondata?.settings?.data?.type;
      //All Role
      if (this.settingMainRole != null && this.settingMainRole === 'all') {
        this.setting.radioBtn_setting = 'all_radioBtn_setting';
      } else if (this.settingMainRole != null && this.settingMainRole === 'team') {
        this.setting.radioBtn_setting = 'team_radioBtn_setting';
      } else {
        this.setting.radioBtn_setting = 'null';
      }

      // All Sub Roles
      this.settingSubRoles = this.jsondata?.settings?.data?.values;
      this.setting.viewOrg_chekBox_setting =
        this.settingSubRoles?.view || false;
      this.setting.addOrg_chekBox_setting =
        this.settingSubRoles?.add || false;
      this.setting.editOrg_chekBox_setting =
        this.settingSubRoles?.edit || false;
      this.setting.deleteOrg_chekBox_setting =
        this.settingSubRoles?.delete || false;

      // leave management data
      // leave management data main role
      this.leaveManagement = this.jsondata?.leave_data?.leave_management;
      this.leave_management.leave_managementEnabled =
        this.leaveManagement || false;
      //Main Role for team and all
      this.leaveManagementMainRole = this.jsondata?.leave_data?.data?.type;
      //All Role
      if (
        this.leaveManagementMainRole != null &&
        this.leaveManagementMainRole === 'all'
      ) {
        this.leave_management.radioBtn_leave_management =
          'all_radioBtn_leave_management';
      } else if (
        this.leaveManagementMainRole != null &&
        this.leaveManagementMainRole === 'team'
      ) {
        this.leave_management.radioBtn_leave_management =
          'team_radioBtn_leave_management';
      } else {
        this.leave_management.radioBtn_leave_management = 'null';
      }
      // All Sub Roles
      this.leaveSubRoles = this.jsondata?.leave_data?.data?.values;
      this.leave_management.viewListAllLeaves_chekBox_leave_management =
        this.leaveSubRoles?.view_leave || false;
      this.leave_management.acceptLeaves_chekBox_leave_management =
        this.leaveSubRoles?.accept || false;
      this.leave_management.rejectLeaves_chekBox_leave_management =
        this.leaveSubRoles?.reject || false;
      this.leave_management.updateLeaves_chekBox_leave_management =
        this.leaveSubRoles?.update || false;
      this.leave_management.leaveReport_chekBox =
        this.leaveSubRoles?.view_leave_report || false;
      this.leave_management.resetLeave_chekBox =
        this.leaveSubRoles?.reset_leave || false;
      this.leave_management.undoLeave_chekBox =
        this.leaveSubRoles?.undo_leave || false;
      // attendance management data
      // attendance management data main role
      this.attendanceManagement =
        this.jsondata?.attendance_data?.attentance_management;
      this.attendance_managment.attendace_managementEnable =
        this.attendanceManagement || false;
      // Team or All Role
      this.attendanceMainRole = this.jsondata?.attendance_data?.data?.type;
      //All Role
      if (
        this.attendanceMainRole != null &&
        this.attendanceMainRole === 'all'
      ) {
        this.attendance_managment.radiobtn_attendace_management =
          'attendace_managementEnable_all';
      } else if (
        this.attendanceMainRole != null &&
        this.attendanceMainRole === 'team'
      ) {
        this.attendance_managment.radiobtn_attendace_management =
          'attendace_managementEnable_team';
      } else {
        this.attendance_managment.radiobtn_attendace_management = 'null';
      }

      this.admin_checkbox_value = false;
      this.team_lead = false;
      this.admin = false;
      if (this.jsondata.role_type === 'Team_Lead') {
        this.admin_checkbox_value = true;
        this.team_lead = true;
      } else if (this.jsondata.role_type === 'Admin') {
        this.admin_checkbox_value = true;
        this.admin = true;
      } else if (this.jsondata.role_type === 'Admin_AND_Team_Lead') {
        this.admin_checkbox_value = true;
        this.admin = true;
        this.team_lead = true;
      }
      // All Sub Roles
      this.attendanceSubRoles = this.jsondata?.attendance_data?.data?.values;
      this.attendance_managment.viewAttendance_chkBox_attentance_management =
        this.attendanceSubRoles?.view_attedance || false;
      this.attendance_managment.edit_chkBox_attentance_management =
        this.attendanceSubRoles?.edit || false;
      this.attendance_managment.sheet_chkBox_attentance_management =
        this.attendanceSubRoles?.sheet || false;
      this.attendance_managment.report_chkBox_attentance_management =
        this.attendanceSubRoles?.report || false;
      this.attendance_managment.delete_chkBox_attentance_management =
        this.attendanceSubRoles?.delete || false;

      this.attendance_managment.update_chkBox_attentance_management =
        this.attendanceSubRoles?.update || false;
      // this.attendanceTpye = value?.data?.attandance_type;

      // event Management
      this.eventManagement = this.jsondata?.event_data?.event_managment;
      this.event_managment.event_managementEnable =
        this.eventManagement || false;
      // Team or All Role
      this.eventMainRole = this.jsondata?.event_data?.data?.type;
      //All Role
      if (this.eventMainRole != null && this.eventMainRole === 'all') {
        this.event_managment.radiobtn_event_management =
          'event_managementEnable_all';
      } else if (this.eventMainRole != null && this.eventMainRole === 'team') {
        this.event_managment.radiobtn_event_management =
          'event_managementEnable_team';
      } else {
        this.event_managment.radiobtn_event_management = 'null';
      }

      this.admin_checkbox_value = false;
      this.team_lead = false;
      this.admin = false;
      if (this.jsondata.role_type === 'Team_Lead') {
        this.admin_checkbox_value = true;
        this.team_lead = true;
      } else if (this.jsondata.role_type === 'Admin') {
        this.admin_checkbox_value = true;
        this.admin = true;
      } else if (this.jsondata.role_type === 'Admin_AND_Team_Lead') {
        this.admin_checkbox_value = true;
        this.admin = true;
        this.team_lead = true;
      }
      // All Sub Roles
      this.eventSubRoles = this.jsondata?.event_data?.data?.values;
      this.event_managment.view_chkBox_event_management =
        this.eventSubRoles?.view || false;
      this.event_managment.add_chkBox_event_management =
        this.eventSubRoles?.add || false;
      this.event_managment.edit_chkBox_event_management =
        this.eventSubRoles?.edit || false;
      this.event_managment.delete_chkBox_event_management =
        this.eventSubRoles?.delete || false;

      // account managment
      // event Management
      this.accountManagement = this.jsondata?.account_data?.account_managment;
      this.account_managment.account_managementEnable =
        this.accountManagement || false;
      // Team or All Role
      this.accountMainRole = this.jsondata?.account_data?.data?.type;
      //All Role
      if (this.accountMainRole != null && this.accountMainRole === 'all') {
        this.account_managment.radiobtn_account_management =
          'account_managementEnable_all';
      } else if (
        this.accountMainRole != null &&
        this.accountMainRole === 'team'
      ) {
        this.account_managment.radiobtn_account_management =
          'account_managementEnable_team';
      } else {
        this.account_managment.radiobtn_account_management = 'null';
      }

      this.admin_checkbox_value = false;
      this.team_lead = false;
      this.admin = false;
      if (this.jsondata.role_type === 'Team_Lead') {
        this.admin_checkbox_value = true;
        this.team_lead = true;
      } else if (this.jsondata.role_type === 'Admin') {
        this.admin_checkbox_value = true;
        this.admin = true;
      } else if (this.jsondata.role_type === 'Admin_AND_Team_Lead') {
        this.admin_checkbox_value = true;
        this.admin = true;
        this.team_lead = true;
      }
      // All Sub Roles
      this.accountSubRoles = this.jsondata?.account_data?.data?.values;
      this.account_managment.add_supperadmin_account_management =
        this.accountSubRoles?.admin || false;
      this.account_managment.view_chkBox_account_management =
        this.accountSubRoles?.view || false;
      this.account_managment.add_chkBox_account_management =
        this.accountSubRoles?.add || false;
      this.account_managment.edit_chkBox_account_management =
        this.accountSubRoles?.edit || false;
      this.account_managment.delete_chkBox_account_management =
        this.accountSubRoles?.delete || false;
      this.account_managment.export_chkBox_account_management =
        this.accountSubRoles?.export || false;

    } else {
      Swal.fire({
        iconHtml:
          ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Data Lost',
        showConfirmButton: false,
        timer: 3000,
      });
      this.router.navigate(['/setting']);
    }
  }

  // showUserData(uuid: string) {
  //   this.showSpinner = true;
  //   this.addService.updateUser(uuid).then((value) => {

  //   });
  // }


  onEmployeeChange(): void {
    if (this.employee) {
      this.team_lead = false;
      this.admin = false;
    }
  }

  onSelectTL(v: boolean): void {
    this.team_lead = v;
  }

  onSelectAdmin(v: boolean): void {
    this.admin_checkbox_value = v;
  }

  roleCheck(): void { }



  onSubmit(f: NgForm) {

    // team evaluation
    const evaluationobj = {
      evaluation: f.value.evaluation ?? false,
      data: {
        type:
          f.value.all_team_evaluation === 'all_RadioBtn_team_evaluation'
            ? 'all'
            : f.value.all_team_evaluation === 'team_RadioBtn_team_evaluation'
              ? 'team'
              : null,
        values: {
          view: f.value.team_evaluation_viewList ?? false,
          add: f.value.team_evaluation_addNew ?? false,
          update: f.value.team_evaluation_update ?? false,
          sendmail: f.value.team_evaluation_sendEmail ?? false,
        },
      },
    };

    // Setting
    const setting = {
      setting: f.value.setting ?? false,
      data: {
        type:
          f.value.team_setting === 'all_radioBtn_setting'
            ? 'all'
            : f.value.team_setting === 'team_radioBtn_setting'
              ? 'team'
              : null,
        values: {
          view: f.value.viewOrg_chekBox_setting ?? false,
          add: f.value.addOrg_chekBox_setting ?? false,
          edit: f.value.editOrg_chekBox_setting ?? false,
          delete: f.value.deleteOrg_chekBox_setting ?? false,
        },
      },
    };


    // team management
    const managementobj = {
      team_management: f.value.team_management ?? false,
      data: {
        type:
          f.value.all_team_management === 'all_radioBtn_team_management'
            ? 'all'
            : f.value.all_team_management === 'radio_btn_team_management'
              ? 'team'
              : null,
        values: {
          view: f.value.viewPayRoll_chkbox_team_management ?? false,
          update: f.value.updateCheckIn_chkbox_team_management ?? false,
          add: f.value.addNewUser_chkbox_team_management ?? false,
          create: f.value.createPayRoll_chkbox_team_management ?? false,
          delete: f.value.deleteUser_chkbox_team_management ?? false,
          monthly_salary: f.value.montlySalary_chkbox_team_management ?? false,
          updateUser: f.value.updateUser_chkbox_team_management ?? false,
          loanView: f.value.loanView_chkbox_team_management ?? false,
          loanAccept: f.value.loanAccept_chkbox_team_management ?? false,
          loanReject: f.value.loanReject_chkbox_team_management ?? false,
        },
      },
    };

    const managementobj1 = {
      team_management: true,
      data: {
        type: 'team',
        values: {
          view: false,
          update: false,
          add: false,
          create: false,
          delete: false,
          monthly_salary: false,
          updateUser: false,
          loanView: false,
          loanAccept: false,
          loanReject: false,
        },
      },
    };

    // team reasign
    const reasignobj = {
      resign: f.value.resign ?? false,
      data: {
        type:
          f.value.team_resign == 'all_radioBtn_team_resign'
            ? 'all'
            : f.value.team_resign === 'team_radioBtn_team_resign'
              ? 'team'
              : null,
        values: {
          view: f.value.viewList_chekboc_team_resign ?? false,
          accept: f.value.acceptResign_chekboc_team_resign ?? false,
          reject: f.value.rejectResign_chekboc_team_resign ?? false,
        },
      },
    };

    // holidays

    const holidayobj = {
      holidays: f.value.holidays ?? false,
      data: {
        type:
          f.value.team_holidays == 'all_radioBtn_team_holidays'
            ? 'all'
            : f.value.team_holidays === 'team_radioBtn_team_holidays'
              ? 'team'
              : null,
        values: {
          view: f.value.viewList_Chkbox_team_holidays ?? false,
          add: f.value.addNew_Chkbox_team_holidays ?? false,
          update: f.value.update_Chkbox_team_holidays ?? false,
          delete: f.value.delete_Chkbox_team_holidays ?? false,
        },
      },
    };

    // upload media object
    const uploadobj = {
      upload_media: f.value.upload_media ?? false,
      data: {
        type:
          f.value.team_upload_media == 'all_radioBtn_upload_media'
            ? 'all'
            : f.value.team_upload_media === 'team_radioBtn_upload_media'
              ? 'team'
              : null,
        values: {
          view: f.value.viewList_chekBox_upload_media ?? false,
          accept: f.value.uploadMedia_chekBox_upload_media ?? false,
          reject: f.value.deleteMedia_chekBox_upload_media ?? false,
        },
      },
    };
    // leave object
    const leaveobj = {
      leave_management: f.value.leave_management ?? false,
      data: {
        type:
          f.value.radio_leave_management == 'all_radioBtn_leave_management'
            ? 'all'
            : f.value.radio_leave_management ===
              'team_radioBtn_leave_management'
              ? 'team'
              : null,
        values: {
          view_leave:
            f.value.viewListAllLeaves_chekBox_leave_management ?? false,
          accept: f.value.acceptLeaves_chekBox_leave_management ?? false,
          reject: f.value.rejectLeaves_chekBox_leave_management ?? false,
          update: f.value.updateLeaves_chekBox_leave_management ?? false,
          view_leave_report: f.value.leaveReport_chekBox ?? false,
          reset_leave: f.value.resetLeave_chekBox ?? false,
          undo_leave: f.value.undoLeave_chekBox ?? false,


        },
      },
    };

    // attendance object
    const jsonObject = {
      attentance_management: f.value.attendace_management ?? false,
      data: {
        type:
          f.value.radio_team_attendance == 'attendace_managementEnable_all'
            ? 'all'
            : f.value.radio_team_attendance ===
              'attendace_managementEnable_team'
              ? 'team'
              : null,
        values: {
          view_attedance:
            f.value.viewAttendance_chkBox_attentance_management ?? false,
          sheet: f.value.sheet_chkBox_attentance_management ?? false,
          report: f.value.report_chkBox_attentance_management ?? false,
          edit: f.value.edit_chkBox_attentance_management ?? false,
          delete: f.value.delete_chkBox_attentance_management ?? false,
          update: f.value.update_chkBox_attentance_management ?? false
        },
      },
    };

    const eventobj = {
      event_managment: f.value.event_managment ?? false,
      data: {
        type:
          f.value.radio_team_event == 'event_managementEnable_all'
            ? 'all'
            : f.value.radio_team_event === 'event_managementEnable_team'
              ? 'team'
              : null,
        values: {
          view: f.value.view_chkBox_event_management ?? false,
          add: f.value.add_chkBox_event_management ?? false,
          edit: f.value.edit_chkBox_event_management ?? false,
          delete: f.value.delete_chkBox_event_management ?? false,
        },
      },
    };

    const accountobj = {
      account_managment: f.value.account_managment ?? false,
      data: {
        type:
          f.value.radio_team_account == 'account_managementEnable_all'
            ? 'all'
            : f.value.radio_team_account === 'account_managementEnable_team'
              ? 'team'
              : null,
        values: {
          view: f.value.view_chkBox_account_management ?? false,
          admin: f.value.add_supperadmin_account_management ?? false,
          add: f.value.add_chkBox_account_management ?? false,
          edit: f.value.edit_chkBox_account_management ?? false,
          delete: f.value.delete_chkBox_account_management ?? false,
          export: f.value.export_chkBox_account_management ?? false,
        },
      },
    };

    const farm_values = f.value;
    let isActive = f.value.is_active
    if (isActive == true) {
      isActive = 1
    } else {
      isActive = 0
    }
    const isPortalCheckIn = farm_values.is_portal_checkin;
    const isPortalCheckIn_value = farm_values.portalCheckInRadioGroup;
    let portalCheckIn = 'Normal';
    if (isPortalCheckIn) {
      if (isPortalCheckIn_value != false) {
        portalCheckIn = isPortalCheckIn_value;
      }
    }

    const isUserRoleSelected = farm_values.user_role1;
    let roleType = '';
    if (isUserRoleSelected) {
      roleType = 'Employee';
    } else if (farm_values.user_role_admin || farm_values.user_role_team_lead) {
      if (this.admin && !this.team_lead) {
        roleType = 'Admin';
      } else if (!this.admin && this.team_lead) {
        roleType = 'Team_Lead';
      } else if (this.admin && this.team_lead) {
        roleType = 'Admin_AND_Team_Lead';
      }
    }

    const combinedData = {
      role_type: roleType,
      team_evaluation: evaluationobj,
      team_managment: managementobj,
      resign_data: reasignobj,
      holdays_data: holidayobj,
      upload_data: uploadobj,
      leave_data: leaveobj,
      attendance_data: jsonObject,
      event_data: eventobj,
      account_data: accountobj,
      settings: setting,
    };


    if (roleType === 'Team_Lead') {
      combinedData.team_managment = managementobj1;
    } else {
      combinedData.team_managment = managementobj;
    }
    // json nested objects printed
    this.objectDataJson = combinedData;


      // for old code here need to pass department id because of change in flow
    // const  department_id = 1

    // this.showSpinner = true;
    // // add form
    // if (this.stateData_id != undefined) {
    //   this.addService
    //     .updateUserrole(
    //       f.value.role_name,
    //       roleType,
    //       JSON.stringify(combinedData),
    //       isActive,
    //       this.stateData_id
    //     )
    //     .then((value) => {
    //       this.showSpinner = false;
    //       if (value.success == true) {
    //         Swal.fire({
    //           iconHtml:
    //             ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
    //           title: 'User Role Updated Successfully',
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //       } else {
    //         Swal.fire({
    //           iconHtml:
    //             ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
    //           title: value.message,
    //           showConfirmButton: false,
    //           timer: 3000,
    //         });
    //       }
    //     });
    // } else {
    //   this.addService
    //     .addUserrole(
    //       f.value.role_name,
    //       roleType,
    //       JSON.stringify(combinedData),
    //       isActive,
    //        department_id
    //     )
    //     .then((value) => {
    //       this.showSpinner = false;
    //       if (value.success == true) {
    //         Swal.fire({
    //           iconHtml:
    //             ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
    //           title: 'User Role Created Successfully',
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //       } else {
    //         Swal.fire({
    //           iconHtml:
    //             ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
    //           title: value.message,
    //           showConfirmButton: false,
    //           timer: 3000,
    //         });
    //       }
    //     });
    // }
    this.router.navigate(['/setting']);

  }




  onallSelectChange() {
    this.check_all

    if (this.check_all == true) {
      //All Role
      this.slectedEvaluation = 'all'
      this.evaluation.RadioBtn_TeamEvaluation = 'all_RadioBtn_team_evaluation';
      // subroles
      this.evaluation.evaluationEnabled = true,
        this.evaluation.team_evaluation_viewList = true,
        this.evaluation.team_evaluation_addNew = true,
        this.evaluation.team_evaluation_update = true,
        this.evaluation.team_evaluation_sendEmail = true
      // team managment
      this.team_management.radio_btn_management = 'all_radioBtn_team_management';
      //All Role
      this.selected != null && this.selected === 'all';
      // team_management subroles
      this.team_management.team_managementEnabled = true;
      this.team_management.viewPayRoll_chkbox_team_management = true;
      this.team_management.updateCheckIn_chkbox_team_management = true;
      this.team_management.addNewUser_chkbox_team_management = true;
      this.team_management.createPayRoll_chkbox_team_management = true;
      this.team_management.deleteUser_chkbox_team_management = true;
      this.team_management.updateUser_chkbox_team_management = true;
      this.team_management.montlySalary_chkbox_team_management = true;
      this.team_management.loanView_chkbox_team_management = true;
      this.team_management.loanAccept_chkbox_team_management = true;
      this.team_management.loanReject_chkbox_team_management = true;

      // Resign Data
      // resign main role
      this.resign.resignEnabled = true;
      this.resignRoles === 'all'
      this.resign.radioBtn_resign = 'all_radioBtn_team_resign';

      // All Sub Roles
      this.resign.viewList_chekboc_team_resign = true;
      this.resign.acceptResign_chekboc_team_resign = true;
      this.resign.rejectResign_chekboc_team_resign = true;

      // holidays data
      this.holidays.holidaysEnabled = true;
      // holidays data type team or all

      //All Role
      this.holidaysMainRole === 'all'
      this.holidays.radioBtn_holidays = 'all_radioBtn_team_holidays'
      // All Sub Roles
      this.holidays.viewList_Chkbox_team_holidays = true;
      this.holidays.addNew_Chkbox_team_holidays = true;
      this.holidays.update_Chkbox_team_holidays = true;
      this.holidays.delete_Chkbox_team_holidays = true;

      // upload media data
      // upload media main role
      this.upload_media.upload_mediaEnabled = true;
      // holidays data type team or all
      this.mediaMainRole === 'all'
      this.upload_media.radioBtn_upload_media = 'all_radioBtn_upload_media'

      // All Sub Roles
      this.upload_media.viewList_chekBox_upload_media = true;
      this.upload_media.uploadMedia_chekBox_upload_media = true;
      this.upload_media.deleteMedia_chekBox_upload_media = true;
      // leave management data
      // leave management data main role
      this.leave_management.leave_managementEnabled = true;
      //Main Role for team and all
      //All Role

      this.leaveManagementMainRole === 'all'

      this.leave_management.radioBtn_leave_management =
        'all_radioBtn_leave_management';

      // All Sub Roles
      this.leave_management.viewListAllLeaves_chekBox_leave_management = true;
      this.leave_management.acceptLeaves_chekBox_leave_management = true;
      this.leave_management.rejectLeaves_chekBox_leave_management = true;
      this.leave_management.updateLeaves_chekBox_leave_management = true;
      this.leave_management.leaveReport_chekBox = true;
      this.leave_management.resetLeave_chekBox = true;
      this.leave_management.undoLeave_chekBox = true;


      // attendance management data
      // attendance management data main role
      this.attendance_managment.attendace_managementEnable = true;
      // Team or All Role

      this.attendanceMainRole === 'all'

      this.attendance_managment.radiobtn_attendace_management =
        'attendace_managementEnable_all';

      // All Sub Roles
      this.attendance_managment.viewAttendance_chkBox_attentance_management = true;
      this.attendance_managment.edit_chkBox_attentance_management = true;
      this.attendance_managment.sheet_chkBox_attentance_management = true;
      this.attendance_managment.report_chkBox_attentance_management = true;
      this.attendance_managment.delete_chkBox_attentance_management = true;
      this.attendance_managment.update_chkBox_attentance_management = true;
      // this.attendanceTpye = value?.data?.attandance_type;


      // Setting management data
      // Setting management data main role
      this.setting.settingEnabled = true;
      // Team or All Role
      this.settingMainRole === 'all';
      this.setting.radioBtn_setting = 'all_radioBtn_setting';
      // All Sub Roles Setting
      this.setting.viewOrg_chekBox_setting = true;
      this.setting.addOrg_chekBox_setting = true;
      this.setting.editOrg_chekBox_setting = true;
      this.setting.deleteOrg_chekBox_setting = true;


      // event Management
      this.event_managment.event_managementEnable = true;
      //All Role
      this.eventMainRole === 'all'
      this.event_managment.radiobtn_event_management = 'event_managementEnable_all';
      // All Sub Roles
      this.event_managment.view_chkBox_event_management = true;
      this.event_managment.add_chkBox_event_management = true;
      this.event_managment.edit_chkBox_event_management = true;
      this.event_managment.delete_chkBox_event_management = true;

      // account managment
      // event Management
      this.account_managment.account_managementEnable = true;
      // Team or All Role
      //All Role'
      this.accountMainRole === 'all'
      this.account_managment.radiobtn_account_management = 'account_managementEnable_all';


      // All Sub Roles
      this.account_managment.add_supperadmin_account_management = true;
      this.account_managment.view_chkBox_account_management = true;
      this.account_managment.add_chkBox_account_management = true;
      this.account_managment.edit_chkBox_account_management = true;
      this.account_managment.delete_chkBox_account_management = true;
      this.account_managment.export_chkBox_account_management = true;


    } else {
      //All Role
      this.slectedEvaluation = 'null'
      // subroles
      this.evaluation.evaluationEnabled = false,
        this.evaluation.team_evaluation_viewList = false,
        this.evaluation.team_evaluation_addNew = false,
        this.evaluation.team_evaluation_update = false,
        this.evaluation.team_evaluation_sendEmail = false,

        // team managment
        //All Role
        this.selected != null && this.selected === 'null';
      // team_management subroles
      this.team_management.team_managementEnabled = false;
      this.team_management.viewPayRoll_chkbox_team_management = false;
      this.team_management.updateCheckIn_chkbox_team_management = false;
      this.team_management.addNewUser_chkbox_team_management = false;
      this.team_management.createPayRoll_chkbox_team_management = false;
      this.team_management.deleteUser_chkbox_team_management = false;
      this.team_management.updateUser_chkbox_team_management = false;
      this.team_management.montlySalary_chkbox_team_management = false;
      this.team_management.loanView_chkbox_team_management = false;
      this.team_management.loanAccept_chkbox_team_management = false;
      this.team_management.loanReject_chkbox_team_management = false;

      // Resign Data
      // resign main role
      this.resign.resignEnabled = false;
      this.resignRoles === 'null'
      this.resign.radioBtn_resign = 'null';

      // All Sub Roles
      this.resign.viewList_chekboc_team_resign = false;
      this.resign.acceptResign_chekboc_team_resign = false;
      this.resign.rejectResign_chekboc_team_resign = false;

      // holidays data
      this.holidays.holidaysEnabled = false;
      // holidays data type team or all

      //All Role
      this.holidaysMainRole === 'null'
      this.holidays.radioBtn_holidays = 'null'
      // All Sub Roles
      this.holidays.viewList_Chkbox_team_holidays = false;
      this.holidays.addNew_Chkbox_team_holidays = false;
      this.holidays.update_Chkbox_team_holidays = false;
      this.holidays.delete_Chkbox_team_holidays = false;

      // upload media data
      // upload media main role
      this.upload_media.upload_mediaEnabled = false;
      // holidays data type team or all
      this.mediaMainRole = 'null'
      this.upload_media.radioBtn_upload_media = 'null'

      // All Sub Roles
      this.upload_media.viewList_chekBox_upload_media = false;
      this.upload_media.uploadMedia_chekBox_upload_media = false;
      this.upload_media.deleteMedia_chekBox_upload_media = false;


      // Setting management data
      // Setting management data main role
      this.setting.settingEnabled = false;
      // Team or All Role
      this.settingMainRole = 'null'
      this.setting.radioBtn_setting = 'null'
      // All Sub Roles Setting
      this.setting.viewOrg_chekBox_setting = false;
      this.setting.addOrg_chekBox_setting = false;
      this.setting.editOrg_chekBox_setting = false;
      this.setting.deleteOrg_chekBox_setting = false;



      // leave management data
      // leave management data main role
      this.leave_management.leave_managementEnabled = false;
      //Main Role for team and all
      //All Role

      this.leaveManagementMainRole = 'null'

      this.leave_management.radioBtn_leave_management = 'null';

      // All Sub Roles
      this.leave_management.viewListAllLeaves_chekBox_leave_management = false;
      this.leave_management.acceptLeaves_chekBox_leave_management = false;
      this.leave_management.rejectLeaves_chekBox_leave_management = false;
      this.leave_management.updateLeaves_chekBox_leave_management = false;
      this.leave_management.leaveReport_chekBox = false;
      this.leave_management.resetLeave_chekBox = false;
      this.leave_management.undoLeave_chekBox = false;


      // attendance management data
      // attendance management data main role
      this.attendance_managment.attendace_managementEnable = false;
      // Team or All Role

      this.attendanceMainRole = 'null'

      this.attendance_managment.radiobtn_attendace_management = 'null';

      // All Sub Roles
      this.attendance_managment.viewAttendance_chkBox_attentance_management = false;
      this.attendance_managment.edit_chkBox_attentance_management = false;
      this.attendance_managment.sheet_chkBox_attentance_management = false;
      this.attendance_managment.report_chkBox_attentance_management = false;
      this.attendance_managment.delete_chkBox_attentance_management = false;
      this.attendance_managment.update_chkBox_attentance_management = false;


      // this.attendanceTpye = value?.data?.attandance_type;

      // event Management
      this.event_managment.event_managementEnable = false;
      //All Role
      this.eventMainRole = 'null'
      this.event_managment.radiobtn_event_management = 'null';
      // All Sub Roles
      this.event_managment.view_chkBox_event_management = false;
      this.event_managment.add_chkBox_event_management = false;
      this.event_managment.edit_chkBox_event_management = false;
      this.event_managment.delete_chkBox_event_management = false;

      // account managment
      // event Management
      this.account_managment.account_managementEnable = false;
      // Team or All Role
      //All Role'
      this.accountMainRole = 'null'
      this.account_managment.radiobtn_account_management = 'null';


      // All Sub Roles
      this.account_managment.add_supperadmin_account_management = false;
      this.account_managment.view_chkBox_account_management = false;
      this.account_managment.add_chkBox_account_management = false;
      this.account_managment.edit_chkBox_account_management = false;
      this.account_managment.delete_chkBox_account_management = false;
      this.account_managment.export_chkBox_account_management = false;



    }

  }

}
